import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';
import React, { FC } from 'react';

import styled from './MainBonus.module.scss';
import { IconV2 } from '@src/atoms/IconV2';
import { getPlural } from '@src/utils/getPlural';

interface IMainBonusProps {
  mainBonus?: string;
  isArrow?: boolean;
  bonusesCount?: number;
  isMulti?: boolean;
}

export const MainBonus: FC<IMainBonusProps> = ({ mainBonus, isArrow, bonusesCount, isMulti }) => {
  if (isMulti) return null;
  return (
    <>
      {isArrow ? (
        <Box gap={4} marginTop={2}>
          <IconV2 id={'bonusesArrowIcon'} name={'linear-arrows-long-right'} size={24} />
          <Box gap={4}>
            <Text id={'bonusesCountText'} weight={'bold'} color={'statusSuccessBright'}>
              +{bonusesCount}
            </Text>
            <Text id={'bonusText'} weight={'bold'}>
              {getPlural(Number(bonusesCount), ['бонус', 'бонуса', 'бонусов'])}
            </Text>
          </Box>
        </Box>
      ) : (
        <Box
          className={styled.bonusContainer}
          bgColor={'basicGreyLight'}
          paddingTop={8}
          paddingBottom={8}
          paddingLeft={12}
          paddingRight={12}
          justifyContent={'center'}
          marginTop={2}
        >
          <Box
            className={styled.bonusLabel}
            bgColor={'secondaryOrange'}
            paddingTop={2}
            paddingBottom={2}
            paddingRight={12}
            paddingLeft={12}
            justifyContent={'center'}
          >
            <Text id={'bonusLabelText'} size={'caption'}>
              Бонус
            </Text>
          </Box>
          <Text id="bonusText" size={'secondary'}>
            {mainBonus}
          </Text>
        </Box>
      )}
    </>
  );
};
